<template>
  <div class="home">
    <transition name="fade">
      <div class="loading" v-if="loaded"></div>
    </transition>
    <Calc></Calc>
  </div>
</template>

<script>
// @ is an alias to /src
import Calc from "@/components/Calc.vue";

export default {
  name: "Home",
  components: { Calc },
  data() {
    return {
      loaded: true,
      tutorial: true,
    };
  },
  mounted() {
    this.$nextTick(function () {
      setTimeout(() => {
        this.loaded = false;
      }, 500);
    });
  },
};
</script>

<style scoped lang="scss">
.home {
  margin-top: 30px;
}
.loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("/static/img/loading.gif"), rgba(50, 50, 50, 1);
  background-repeat: no-repeat;
  background-position: center;
  z-index: 999;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

